import { get, post, del } from '@api/request';

export async function fetchSelectionFields(services, authenticationToken) {
  const url = `${services.integrityService}/integrity/prodigyai/querybuilder/selectionfields`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createQuery(
  services,
  authenticationToken,
  { queryDescription, fieldsToReturn, pYear, asOfRollCorr },
) {
  const url = `${services.integrityService}/integrity/prodigyai/querybuilder/createquery`;
  const { body } = await post(authenticationToken, url, {
    queryDescription,
    fieldsToReturn,
    pYear,
    asOfRollCorr,
  });
  return body;
}

export async function downloadQueryResults(
  { integrityService },
  authenticationToken,
  { queryId },
) {
  const url = `${integrityService}/integrity/prodigyai/querybuilder/download/${queryId}`;
  const response = await fetch(url, {
    headers: {
      Authorization: authenticationToken,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to download results');
  }

  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = `query-results-${queryId}.xlsx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
}

export async function fetchSavedQueries(
  { integrityService },
  authenticationToken,
) {
  const url = `${integrityService}/integrity/prodigyai/querybuilder/saved`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function saveQuery(
  { integrityService },
  authenticationToken,
  { queryData },
) {
  const url = `${integrityService}/integrity/prodigyai/querybuilder/save`;
  const { body } = await post(authenticationToken, url, queryData);
  return body;
}

export async function deleteQuery(
  { integrityService },
  authenticationToken,
  { queryId },
) {
  const url = `${integrityService}/integrity/prodigyai/querybuilder/${queryId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}
